<template>
  <div class="passwordLogin">
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
    >
      <el-form-item prop="username">
        <el-input
          v-model="dataForm.username"
          :placeholder="$t('login.account2Placeholder')"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item prop="username">
        <el-input
          v-model="dataForm.password"
          :placeholder="$t('login.passwordPlaceholder')"
          type="password"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <div class="center m-y-40">
        <div>
          <el-button
            class="submitBtn"
            :class="{ disabledSubmitBtn: !agreeChecked }"
            type="primary"
            @click="dataFormSubmitHandle"
            >登 录</el-button
          >
        </div>
      </div>
      <!-- <div class="center">
        <el-checkbox v-model="agreeChecked" class="submitTip">
          阅读并同意以下协议
          <a @click.stop="$emit('userAgree')">{{
            $t("login.servicePolicy")
          }}</a>
          <a @click.stop="$emit('privacyAgree')">{{
            $t("login.userPrivacyPolicy")
          }}</a>
        </el-checkbox>
      </div> -->
    </el-form>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { getEnvConfig } from '@/utils/envConfig.js'
import { Base64 } from 'js-base64'

export default {
  data () {
    return {
      dataForm: {
        username: '',
        password: '',
        grant_type: 'password',
        appCode: window.SITE_CONFIG.appCode,
        client_id: 'shopping',
        loginType: '0',
        env: getEnvConfig().env,
        domain: getEnvConfig().domain
      },
      routerForm: '',
      agreeChecked: true
    }
  },
  computed: {
    dataRule () {
      return {
        username: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          if (!this.agreeChecked) {
            const h = this.$createElement
            this.$msgbox({
              message: h('p', {}, [
                '登录即代表您同意',
                h(
                  'a',
                  {
                    class: 'pointer',
                    on: {
                      click: () => {
                        this.$emit('userAgree')
                      }
                    }
                  },
                  '《宁东工业超市服务协议》'
                ),
                '与',
                h(
                  'a',
                  {
                    class: 'pointer',
                    on: {
                      click: () => {
                        this.$emit('privacyAgree')
                      }
                    }
                  },
                  '《用户隐私权政策》'
                ),
                '，继续登录吗?'
              ]), // "登录即代表您同意《Plantmate服务协议》与《用户隐私权政策》，继续登录吗?",
              title: '提示',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'none'
            })
              .then(() => {
                this.agreeChecked = true
              })
              .catch(() => {})
            return
          }
          let params = Object.assign({}, this.dataForm)
          params.password = Base64.encode(this.dataForm.password)
          this.$http
            .post(
              `/auth/login?env=${params.env}&domain=${params.domain}`,
              params
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              console.log('passwordLogin', res)

              Cookies.set('access_token_shop', res.data.access_token)
              Cookies.set('username_shop', res.data.username)
              // 学习平台cookie登录共享
              Cookies.set('access_token_shop', res.data.access_token, {
                domain: location.origin.includes('plantmate.supcon.com')
                  ? '.supcon.com'
                  : '.plantmate.com'
              })
              Cookies.set('username_shop', res.data.username, {
                domain: location.origin.includes('plantmate.supcon.com')
                  ? '.supcon.com'
                  : '.plantmate.com'
              })
              this.bus.$emit('getUserMenuPerm')
              this.bus.$emit('hideLoginDialog')
              console.log('redirectUrl')

              const redirectUrl = this.toRedirectUrl()
              if (redirectUrl) {
                setTimeout(() => {
                  window.location.href = redirectUrl
                }, 300)
              } else {
                setTimeout(() => {
                  window.location.href = '/'
                }, 300)
              }
            })
            .catch((e) => {
              console.log(e)
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 重定向地址
    toRedirectUrl () {
      const redirectUrl = sessionStorage.getItem('redirectUrl')
      if (redirectUrl) {
        sessionStorage.removeItem('redirectUrl')
        // window.location.href = redirectUrl
      }
      return redirectUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.passwordLogin {
  width: 100%;
  padding: 24px;
  padding-top: 40px;
  .submitBtn {
    width: 183px;
    height: 43px;
    border-radius: 8px;
    background: #2a54d1;
    box-shadow: 0px 4px 10px 0px rgba(116, 183, 255, 0.3);
    display: inline-block;
  }
  .disabledSubmitBtn {
    background-color: #74b7ff;
    opacity: 0.3;
  }
  .submitTip {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #666666;
    margin-top: 8px;
    ::v-deep .el-checkbox__label {
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      color: #666666;
    }
    a {
      color: #2a54d1;
    }
  }
}
</style>

<style>
.pointer {
  cursor: pointer;
}
</style>
